import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { Input, Image, Table, Popconfirm, message, Button } from "antd";
import { EyeOutlined, EditOutlined, DeleteOutlined, TruckOutlined } from "@ant-design/icons";

import { getEquipments, deleteEquipment } from "../../api/equipment";
import { getFileUrl } from "../../api/file";

import BlueButton from "../../components/shared/BlueButton";
import PageHeader from "../../components/shared/PageHeader";
import StatusBadge from "../../components/shared/StatusBadge";

const { Search } = Input;

export default function EquipmentsView() {
    const [isLoading, setIsLoading] = useState(false);
    const [equipments, setEquipments] = useState(null);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [searchQuery, setSearchQuery] = useState(null);
    const [perPage, setPerPage] = useState(10);

    const onShowSizeChange = (currentPage, pageSize) => {
        setPage(currentPage);
        setPerPage(pageSize);
    }

    const columns = [
        {
            title: "SN",
            dataIndex: "id",
            key: "id",
            render: (text, record, index) => index + 1,
        },
        {
            title: "Image",
            dataIndex: "image",
            key: "image",
            render: (text, record) => {
                const avatar = record.avatars?.filter(a => a.isActive)[0];
                if (!avatar) return <div className="bg-orange-300 w-[48px] h-[48px] flex items-center justify-center rounded-full"><TruckOutlined className="text-black" /></div>;
                return <Image src={getFileUrl(avatar)} preview={false} style={{ width: "48px", height: "48px", objectFit: "cover" }} className="rounded-full" />
            },
        },
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
        },
        {
            title: "Make",
            dataIndex: "make",
            key: "make",
        },
        {
            title: "Model/Size",
            dataIndex: "model",
            key: "model",
        },
        {
            title: "Type",
            dataIndex: "type",
            key: "type",
            render: (text) => <p className="capitalize">{text}</p>
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (text) => <StatusBadge status={text} />
        },
        {
            title: "Actions",
            key: "action",
            render: (text, record) => (
                <div className="flex gap-2">
                    <Link to={`/equipments/${record.id}`}>
                        <Button type="text" icon={<EyeOutlined />} />
                    </Link>
                    <Link to={`/equipments/form/${record.id}`}>
                        <Button type="text" icon={<EditOutlined />} />
                    </Link>
                    <Popconfirm
                        title="Delete the equipment"
                        description="Are you sure to delete this equipment?"
                        onConfirm={async () => await deleteEquipment(record.id).then(async () => {
                            await fetchEquipments({ page, perPage, q: searchQuery });
                            message.success("Equipment deleted successfully");
                        })}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button type="text" icon={<DeleteOutlined />} danger />
                    </Popconfirm>
                </div>
            )
        }
    ]

    const fetchEquipments = useCallback(async ({ page, q, perPage }) => {
        try {
            setIsLoading(true);
            const { total, results } = await getEquipments({
                page, perPage, q
            });
            setTotal(total);
            setEquipments(results);
            setIsLoading(false);
        } catch (error) {
            console.error(error)
        }
    }, [])

    useEffect(() => {
        fetchEquipments({ page, perPage, q: searchQuery });
    }, [fetchEquipments, page, perPage, searchQuery])



    return (
        <main className="min-h-full flex flex-col space-y-6">
            <PageHeader title="Equipments" home="App" route="/" />

            <div className="flex-grow bg-white ml-6 p-6 flex flex-col space-y-6">
                <div className="flex justify-between">
                    <Link to="/equipments/form">
                        <BlueButton type="primary" >Add New Equipment</BlueButton>
                    </Link>
                    <Search
                        placeholder="Search Equipment"
                        style={{
                            width: 200,
                        }}
                        allowClear
                        onSearch={(q) => setSearchQuery(q)}
                    />
                </div>


                <section>
                    <Table
                        dataSource={equipments}
                        columns={columns}
                        loading={isLoading}
                        pagination={{
                            total,
                            pageSize: perPage,
                            current: page,
                            onChange: (page) => setPage(page),
                            onShowSizeChange: onShowSizeChange,
                            showSizeChanger: true,
                        }}
                    />
                </section>


            </div>

        </main>
    )
}
